// components/scrollSection.jsx
import React, { useEffect, useState } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import './styles/scrollSection.css';

gsap.registerPlugin(ScrollTrigger);

const ScrollSection = () => {
  const [activeContent, setActiveContent] = useState(0);

  const scrollContent = [
    {
      heading: "Mobile First",
      text: "Every design starts with mobile. We create experiences that feel native, fast, and intuitive on the devices your users actually use.",
      number: "01",
      image: "/mobile-first.png"
    },
    {
      heading: "Desktop Power",
      text: "Scale seamlessly to desktop with layouts that take full advantage of larger screens while maintaining the same fluid experience.",
      number: "02",
      image: "/desktop-power.png"
    },
    {
      heading: "Design Systems",
      text: "Comprehensive design systems that ensure consistency, speed up development, and scale with your product as it grows.",
      number: "03",
      image: "/design-systems.png"
    }
  ];

  useEffect(() => {
    const scrollSection = document.querySelector('.scroll-section-wrapper');
    if (!scrollSection) return;

    // Single trigger that tracks scroll progress through the section
    const trigger = ScrollTrigger.create({
      trigger: scrollSection,
      start: 'top top',
      end: 'bottom bottom',
      onUpdate: (self) => {
        // Split progress into 3 equal zones: 0-33%, 33-66%, 66-100%
        const index = Math.min(2, Math.floor(self.progress * 3));
        setActiveContent(index);
      }
    });

    return () => {
      trigger.kill();
    };
  }, []);

  return (
    <div className="scroll-section-wrapper">
      <div className="scroll-sticky">
        <div className="scroll-content">
          <div className="scroll-image-container">
            {scrollContent.map((content, index) => (
              <div
                key={index}
                className={`scroll-image ${activeContent === index ? 'active' : ''}`}
              >
                {/* 👇 התמונה תופיע כאן! */}
                {content.image && (
                  <img 
                    src={content.image} 
                    alt={content.heading}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      borderRadius: '2rem',
                      position: 'absolute',
                      top: 0,
                      left: 0
                    }}
                  />
                )}
                <span 
                  style={{
                    position: 'relative',
                    zIndex: 2,
                    fontSize: '5rem',
                    fontWeight: 900
                  }}
                >
                  {content.number}
                </span>
              </div>
            ))}
          </div>
          <div className="scroll-text-container">
            {scrollContent.map((content, index) => (
              <div
                key={index}
                className={`scroll-text ${activeContent === index ? 'active' : ''}`}
              >
                <h3>{content.heading}</h3>
                <p>{content.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScrollSection;